import React from "react";
import Content from "carbon-react/lib/components/content";
import UserStatusPill from "../UserStatusPill";
import { Row, Column } from "carbon-react/lib/components/row";
import Heading from "carbon-react/lib/components/heading";
import UserEmailVerifiedPill from "../UserEmailVerifiedPill";
import UserActionsButton from "./UserActionsButton";
import { useLocalization } from "../../../contexts/localization/Localization";

const UserInformation = ({ user, onUpdateUser }) => {
  const { getLocalizedDateStringFromUtcValue } = useLocalization();

  return (
    <>
      <Row columns="2">
        <Column>
          <div id="user-info-name">
            <Heading
              as="primary"
              title={user?.name}
              subheader={`auth0 ID: ${user?.userId}`}
              divider={false}
              separator={false}
            />
          </div>
        </Column>
        <Column columnAlign="right">
          <UserActionsButton user={user} onUpdateUser={onUpdateUser} />
        </Column>
      </Row>
      <Row>
        <Column>
          <Content as="primary" title="Status">
            <span id="user-info-status">
              <UserStatusPill user={user} />
            </span>
          </Content>
        </Column>
        <Column>
          <Content as="primary" title="Email address">
            <span id="user-info-email">
              {user?.email} {"  "}
              <UserEmailVerifiedPill user={user} />
            </span>
          </Content>
        </Column>
        <Column>
          <Content as="primary" title="Signed up">
            <span id="user-info-signed-up">
              {user?.createdAtUTC
                ? getLocalizedDateStringFromUtcValue(user?.createdAtUTC)
                : "N/A"}
            </span>
          </Content>
        </Column>
        <Column>
          <Content as="primary" title="Last log in">
            <span id="user-info-last-login">
              {user?.lastLogin
                ? getLocalizedDateStringFromUtcValue(user?.lastLogin)
                : "N/A"}
            </span>
          </Content>
        </Column>
      </Row>
    </>
  );
};

export default UserInformation;
